// extracted by mini-css-extract-plugin
export default {"container":"Dq-z","brandName":"Eq-z","productName":"Fq-z","productNamePdpEnhancements":"Gq-z","breakLongProductName":"Hq-z"};